import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';
import { EExportarModeloCrf } from '@app/enums/EExportarModeloCrf';

const controller = "crfExportar"

//#region Exportação de Planilhas RFA
export const exportaCrfPlanilhaRfaAnoMes = (projetoId: string, nomeArquivo: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/${controller}/crf/planilha/rfaAnoMes?projetoId=${projetoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => generateElementDownload(resp, nomeArquivo)),
  );
};

export const exportaCrfPlanilhaRfaAntiga = (
  id: any,
  nomeArquivo: string,
  numero: number,
  revisao: number,
  dataAprovacao: string,
) => {
  let d: any[] = dataAprovacao.split('/');
  let data: any = new Date(d[2], d[1] - 1, d[0]);
  dataAprovacao = data.toISOString();

  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(
      urlBase +
      `/api/${controller}/crf/planilha/rfa?id=${id}&numero=${numero}&revisao=${revisao}&dataAprovacao=${dataAprovacao}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getJwt()}`,
        },
      },
    ).then(resp => generateElementDownload(resp, nomeArquivo)),
  );
};
//#endregion

//#region Exportação de Planilhas CAPEX
export const exportaCrfPlanilhaCapexAntiga = (
  id: any,
  nomeArquivo: string,
  numero: number,
  revisao: number,
  dataAprovacao: string,
) => {
  let d: any[] = dataAprovacao.split('/');
  let data = new Date(d[2], d[1] - 1, d[0]);
  dataAprovacao = data.toISOString();

  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(
      urlBase +
      `/api/crfExportar/crf/planilha/capex?id=${id}&numero=${numero}&revisao=${revisao}&dataAprovacao=${dataAprovacao}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getJwt()}`,
        },
      },
    ).then(resp => generateElementDownload(resp, nomeArquivo)),
  );
};
//#endregion

//#region Exportação de Planilhas ANUAL
export const exportarCrfPlanilhaOrcadoEconomicoAnoMes = (id: any, nomeArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/${controller}/crf/planilha/orcadoAnual/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => generateElementDownload(resp, nomeArquivo)),
  );
};

//#endregion


export const exportaCrfModelo = (tipo: EExportarModeloCrf) => {
  let urlBase = window.location.origin;
  let nomeArquivo = '';
  switch (tipo) {
    case EExportarModeloCrf.MODELO_IMPORTACAO_TAP:
      urlBase += `/api/${controller}/crf/modelo/importacao/tap`;
      nomeArquivo = 'MODELO - Importacao TAP CRFCH FINPLAN AAAA.xlsx';
      break;
    case EExportarModeloCrf.MODELO_IMPORTACAO_CAPEX:
      urlBase += `/api/${controller}/crf/planilha/modelo/importacao/capex`;
      nomeArquivo = 'MODELO - Importacao ORÇADO PLURIANUAL CrFch de AAAA.xlsx';
      break;
    case EExportarModeloCrf.MODELO_IMPORTACAO_RFA:
      urlBase += `/api/${controller}/crf/planilha/modelo/importacao/rfa`;
      nomeArquivo = 'MODELO - Importacao RFA CrFch de AAAA.xlsx';
      break;
    case EExportarModeloCrf.MODELO_IMPORTACAO_ANUAL:
      urlBase += `/api/${controller}/crf/planilha/modelo/importacao/anual`;
      nomeArquivo = 'MODELO - Importacao ORÇADO ANUAL CrFch de AAAA.xlsx';
      break;
  }

  trackPromise(
    Axios.get(urlBase, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => generateElementDownload(resp, nomeArquivo)),
  );
};

//Private
function generateElementDownload(resp: any, nomeArquivo: string) {
  const url = window.URL.createObjectURL(new Blob([resp.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', nomeArquivo);
  link.setAttribute('id', 'downloadElement');
  document.body.appendChild(link);
  link.click();
  var element = document.getElementById('downloadElement');
  if (element) {
    element.outerHTML = '';
  }
}
